define("settings/components/cancel-plan/slide/features", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "later/utils/compare-strings", "later/utils/time-format"], function (_exports, _component, _templateFactory, _component2, _service, _compareStrings, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tCA--title">
    {{#if this.hasActiveTrial}}
      {{t "account.change_plan.cancellation_feedback.features.title_trial"}}
    {{else}}
      {{t "account.change_plan.cancellation_feedback.features.title"}}
    {{/if}}
  </p>
  
  <div class="tCA--planContainer">
    <div  class="tCA--planContainer__item">
      <p class="tCA--planContainer__title">
        <span class="tCA--title__underline">{{this.planName}}</span>
      </p>
      <p class="tCA--planContainer__subTitle">{{this.currentPlanSubtitle}}</p>
    </div>
  
    <div  class="tCA--planContainer__item">
      {{svg-jar "arrow-right" class="o--icon"}}
    </div>
  
    <div  class="tCA--planContainer__item">
      <p class="tCA--planContainer__title">
        <span class="tCA--title__underline tCA--title__underline--grey">{{t "account.change_plan.cancellation_feedback.free"}}</span>
      </p>
      <p class="tCA--planContainer__subTitle">{{t "account.change_plan.cancellation_feedback.features.plan_subtitles.free"}}</p>
    </div>
  </div>
  
  <hr>
  
  {{#if this.hasActiveTrial}}
    <p class="u--text--md">
      {{t "account.change_plan.cancellation_feedback.features.are_you_sure_trial"
        date=(moment-format this.trialExpiryMoment "MMM DD, YYYY")
      }}
    </p>
  {{else}}
    <p class="u--text--md">{{t "account.change_plan.cancellation_feedback.features.are_you_sure"}}</p>
  {{/if}}
  
  <ul class="tCA--featureList">
    {{#each this.features as |feature|}}
      <li class="tCA--featureList__li">
        {{svg-jar "close" class="o--icon u--m__r__xs"}}
        {{t (concat "account.change_plan.cancellation_feedback.features." feature)}}
      </li>
    {{/each}}
  </ul>
  
  */
  {
    "id": "d5z6PGDh",
    "block": "[[[10,2],[14,0,\"tCA--title\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.title_trial\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.title\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tCA--planContainer\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"tCA--title__underline\"],[12],[1,[30,0,[\"planName\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__subTitle\"],[12],[1,[30,0,[\"currentPlanSubtitle\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"arrow-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"tCA--title__underline tCA--title__underline--grey\"],[12],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.free\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__subTitle\"],[12],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.plan_subtitles.free\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"hr\"],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.are_you_sure_trial\"],[[\"date\"],[[28,[37,3],[[30,0,[\"trialExpiryMoment\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.are_you_sure\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[10,\"ul\"],[14,0,\"tCA--featureList\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"features\"]]],null]],null],null,[[[1,\"    \"],[10,\"li\"],[14,0,\"tCA--featureList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"close\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,1],[[28,[37,6],[\"account.change_plan.cancellation_feedback.features.\",[30,1]],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[1]],null],[13],[1,\"\\n\"]],[\"feature\"],false,[\"if\",\"t\",\"svg-jar\",\"moment-format\",\"each\",\"-track-array\",\"concat\"]]",
    "moduleName": "settings/components/cancel-plan/slide/features.hbs",
    "isStrictMode": false
  });

  let Features = (_class = class Features extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }

    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }

    get isOnLegacyPlan() {
      return this.auth.currentAccount.get('isOnLegacyPlan');
    }

    get planType() {
      var _this$subscriptionPla;

      return (_this$subscriptionPla = this.subscriptionPlan) === null || _this$subscriptionPla === void 0 ? void 0 : _this$subscriptionPla.planType;
    }

    get planName() {
      var _this$subscriptionPla2;

      return (_this$subscriptionPla2 = this.subscriptionPlan) === null || _this$subscriptionPla2 === void 0 ? void 0 : _this$subscriptionPla2.name;
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    get trialExpiryMoment() {
      return this.auth.currentAccount.trialExpiryMoment;
    }

    get currentPlanSubtitle() {
      if (this.subscriptions.isOnAgencyPlan) {
        return '';
      }

      const planCode = this.isOnLegacyPlan && (0, _compareStrings.areStringsEqual)(this.planType, 'starter') ? 'starter_legacy' : this.planType;
      return this.intl.t("account.change_plan.cancellation_feedback.features.plan_subtitles.".concat(planCode));
    }

    get isNewUser() {
      const createdAt = moment(this.subscriptions.subscriptionCreatedAt * 1000);

      const daysSincePaid = (moment() - createdAt) / _timeFormat.convert.day().toMilliseconds();

      const thresholdForNewUser = 35;
      return daysSincePaid <= thresholdForNewUser;
    }

    get features() {
      if ((0, _compareStrings.areStringsEqual)(this.planType, 'creator')) {
        return ['media_kit', 'brand_campaigns', 'linkinbio', 'bttp'];
      }

      const featuresForNewUsers = ['bttp', 'hashtag_suggestions', 'first_comment', 'analytics', 'collect'];
      const featuresForOlderUsers = ['bttp', 'analytics', 'notes', 'shopify_lib', 'collect'];
      return this.isNewUser ? featuresForNewUsers : featuresForOlderUsers;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = Features;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Features);
});